import { RhFormGroup, RhFormGroupItem, RhInput } from "@rhythm-ui/react";
import React from "react";

type GenericType<T> = {
  values: T;
  valueKey: keyof T;
  classname?: string;
  setReactState: React.Dispatch<React.SetStateAction<T>>;
  options: { value: string; label: string }[];
  __onItemClick?: () => void;
};

const RadioInput = <T extends object>({
  values,
  setReactState,
  valueKey,
  classname,
  options = [],
  __onItemClick,
}: GenericType<T>) => {
  const onChangeHandler = (value: string) => {
    setReactState((state: T) => ({
      ...state,
      [valueKey]: value,
    }));
  };

  const selectedValue = values[valueKey];

  return (
    <RhFormGroup>
      <div className={`flex flex-col w-full ${classname ?? ""}`}>
        {options.map((option: { value: string; label: string }) => (
          <RhFormGroupItem
            className="text-gray-700 cursor-pointer"
            key={option.value}
            control={
              <RhInput
                onChange={(e) => onChangeHandler(e.target.value)}
                type="radio"
                value={option.value}
                checked={selectedValue === option.value}
                onClick={__onItemClick}
                className="m-tnano"
                data-testid={`${valueKey.toString()}-${option.value}`}
              />
            }
            label={option.label}
          />
        ))}
      </div>
    </RhFormGroup>
  );
};

export default RadioInput;
